import { Injectable } from '@angular/core'
import { Store } from '../../../shared/models/store'
import { ChantierDto } from '../http/dto/chantier.dto'
import { SousTraitantsDto } from '../http/dto/sous-traitants.dto'
import { HeurePointeeChantierDto, HeurePointeeDto } from '../http/dto/heure-pointee-chantier.dto'
import { InsertionChantierDto } from '../http/dto/insertion-chantier.dto'
import {SalarieDto} from "../http/dto/salarie.dto";



export interface HomeStateModel {
  selectedChantier: ChantierDto
  heurePointeeChantier: HeurePointeeChantierDto
  searchedSousTraitants: SousTraitantsDto[]
  insertionsChantier: InsertionChantierDto[]
  searchedSalaries:SalarieDto[]
  period: string
  modeSousTraitants: boolean
}

@Injectable({ providedIn: 'root' })
export class HomeState {
  readonly store = new Store<HomeStateModel>({
    selectedChantier: null,
    heurePointeeChantier: null,
    searchedSousTraitants: [],
    insertionsChantier: [],
    searchedSalaries: [],
    period: '',
    modeSousTraitants: false
  })

  static getSelectedChantier = (state: HomeStateModel): ChantierDto => state.selectedChantier
  static getSearchedSousTraitants = (state: HomeStateModel): SousTraitantsDto[] => state.searchedSousTraitants
  static getheurePointeeChantier = (state : HomeStateModel):HeurePointeeChantierDto => state.heurePointeeChantier
  static getInsertionsChantier = (state : HomeStateModel):InsertionChantierDto[] => state.insertionsChantier
  static getSearchedSalaries= (state : HomeStateModel):SalarieDto[] => state.searchedSalaries
  static getPeriod= (state : HomeStateModel):string => state.period
  static getEngagementLg = (state: HomeStateModel): number => state.selectedChantier?.engagementLg
  static getInsertionChantierById =
    (id: number) =>
      (state: HomeStateModel): InsertionChantierDto  =>
        state.insertionsChantier?.find((i) => i.id === id);
  static getHeurePointeeByInsertionId =
    (insertionId: number) =>
      (state: HomeStateModel): HeurePointeeDto =>
        state.heurePointeeChantier?.heures.find(
          (h) => h.id === insertionId
        );

  static getActualModeSousTraitants = (state: HomeStateModel): boolean => state.modeSousTraitants;

}
